import React, { useState, useEffect } from 'react';
import PresetDndContext from '../common/DnD/PresetDndContext';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import FieldListItem from './FieldListItem';
import NewField from './NewField';
import SortableItem from '../common/DnD/SortableItem';
import { handleSortUpdate } from '../common/DnD/sortUpdater';
import {
  handleDestroyField,
  handleCopyField,
  checkFieldResponsesExist,
  hasValidResponses,
} from './constants/handleField';
import {
  adjustSortablesAfterDelete,
  dragSort,
  sortable,
} from '../../helpers/sorters';

const FieldIndex = (props) => {
  const { informantID, setInformantID, fieldset } = props;
  const [fields, setFields] = useState(sortable(props.fields));
  const [fieldValidity, setFieldValidity] = useState([]);

  useEffect(() => {
    checkFieldResponsesExist(fieldset.id).then((res) => {
      if (res.ok) setFieldValidity(res.data.field_validity);
    });
  }, []);

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      let sort = fields.map((obj) => obj.id).indexOf(over.id);
      let backup = [...fields];
      setFields((fields) => dragSort(fields, active, over));
      let sorted = await handleSortUpdate('fields', active.id, sort);
      if (!sorted.ok) setFields(backup);
    }
  };

  const handleDestroy = async (e, id) => {
    e.preventDefault();
    await handleDestroyField(id, (response) => {
      if (response.ok) setFields(adjustSortablesAfterDelete(fields, id));
    });
  };

  const handleCopy = async (e, id) => {
    e.preventDefault();
    await handleCopyField(id, async (response) => {
      if (response.ok) setFields([...fields, response.data.field]);
    });
  };

  return (
    <section className='fields'>
      <h2>Fields</h2>

      <NewField
        fsID={fieldset.id}
        setFields={setFields}
        sortValue={fields.length}
        informantID={informantID}
        setInformantID={setInformantID}
        setFieldValidity={setFieldValidity}
      />

      <div className='editor'>
        <div className='drop-zone'>
          <PresetDndContext handleDragEnd={handleDragEnd}>
            <ol className='orderable ui-sortable'>
              {fields.length ? (
                <SortableContext
                  strategy={verticalListSortingStrategy}
                  items={fields}
                >
                  {fields.map((field) => {
                    return (
                      <SortableItem key={field.id} id={field.id}>
                        <FieldListItem
                          field={field}
                          key={field.id}
                          handleCopy={handleCopy}
                          handleDestroy={handleDestroy}
                          hasValidResponses={hasValidResponses(
                            fieldValidity,
                            field.id
                          )}
                        />
                      </SortableItem>
                    );
                  })}
                </SortableContext>
              ) : (
                <li className='empty'>
                  Add some fields to make this fieldset usable...
                </li>
              )}
            </ol>
          </PresetDndContext>
        </div>
      </div>
    </section>
  );
};

export default FieldIndex;
